export { default } from 'signer-app/parts/minimal-layout/minimal-layout';
